import SecureLS from "secure-ls";

export default class CriptoUtil {
  private static instance: CriptoUtil;
  private encripter: SecureLS = new SecureLS({
    encodingType: "aes",
    encryptionSecret: "Ob@2020",
  });

  private constructor() {}

  public static getInstance(): CriptoUtil {
    if (!CriptoUtil.instance) {
      CriptoUtil.instance = new CriptoUtil();
    }
    return CriptoUtil.instance;
  }

  public getItem(label: string): string {
    const oldVal: string | null = window.localStorage.getItem(label);
    if (oldVal) {
      this.setItem(label, oldVal);
      window.localStorage.removeItem(label);
    }
    return this.encripter.get(`sec_${label}`);
  }
  public setItem(label: string, value: string): void {
    this.encripter.set(`sec_${label}`, value);
  }
  public removeItem(label: string): void {
    this.encripter.remove(label);
    this.encripter.remove(`sec_${label}`);
  }
}
